import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import _isFunction from 'lodash/isFunction';
import ReviewStars from '../../../../common/ReviewStars/ReviewStars';
import ReplyReview from '../ReplyReview/ReplyReview';
import s from './ReviewItemMobile.scss';
import { Avatar, Text, IconButton, PopoverMenu } from 'wix-style-react';
import Share from 'wix-ui-icons-common/Share';
import ReviewDetails from './ReviewDetails';
import moment from 'moment';
import { connect } from 'react-redux';
import { experimentsSelectors } from '@wix/wix-experiments-redux';

const mapStateToProps = ({ initialData, profile, experiments }) => ({
  servicesLegacyMap: initialData.servicesLegacyMap,
  expert: profile.expert,
});

class ReviewItemMobile extends React.Component {
  static propTypes = {
    t: PropTypes.func,
    review: PropTypes.object,
    reviewInModal: PropTypes.bool,
    onReplyReviewClicked: PropTypes.func,
  };

  static defaultProps = {
    reviewInModal: false,
  };

  render() {
    const {
      t,
      review,
      servicesLegacyMap,
      reviewInModal,
      onReplyReviewClicked,
      expert,
    } = this.props;
    return (
      <div
        className={`${s.reviewItemMobile} ${s.reviewItem} ${
          reviewInModal ? s.reviewInModal : ''
        }`}
        data-hook="review-item"
      >
        <div className={s.reviewerDetails}>
          <div className={s.reviewAvatar} data-hook="review-avatar-wrapper">
            <Avatar
              color="A1"
              imgProps={{
                src: review.reviewData.review.clientAvatar,
              }}
              name={review.reviewData.review.clientName}
              size="size60"
            />
          </div>
          <div className={s.reviewDetailsHeader}>
            <Text
              weight="bold"
              size="medium"
              secondary={false}
              light={false}
              tagName="div"
              className={s.reviewName}
            >
              {review.reviewData.review.clientName}
            </Text>
            <ReviewStars fullStars={review.reviewData.review.reviewScore} />
            <Text
              weight="normal"
              size="small"
              weight="thin"
              secondary={true}
              light={false}
              tagName="div"
              className={s.reviewDate}
            >
              {moment(new Date(review.reviewData.reviewDate)).format(
                t('client-expertview-reviews-date-format'),
              )}
            </Text>
          </div>
          {_isFunction(onReplyReviewClicked) && (
            <PopoverMenu
              className={s.replyLink}
              minWidth={0}
              placement="left"
              triggerElement={
                <IconButton priority="secondary" size="small">
                  <Share />
                </IconButton>
              }
            >
              <PopoverMenu.MenuItem
                onClick={() => {
                  onReplyReviewClicked(review);
                  return false;
                }}
                text={t('client-expertview-reviews-reply-mobile-link')}
              />
            </PopoverMenu>
          )}
        </div>
        <div className={s.reviewDetails}>
          <ReviewDetails
            t={t}
            reviewInModal={reviewInModal}
            review={review}
            servicesLegacyMap={servicesLegacyMap}
            descriptionMargin="12px 0 6px"
          />

          {review.reviewData.review.reply && (
            <ReplyReview
              replyDate={review.reviewData.review.reply.replyDate}
              replyBody={review.reviewData.review.reply.replyBody}
              name={expert.personalDetails.name}
              profilePhoto={expert.personalDetails.profilePhoto}
            />
          )}
        </div>
      </div>
    );
  }
}

const ConnectedReviewItemMobile = connect(
  mapStateToProps,
  {},
)(ReviewItemMobile);

export default translate()(ConnectedReviewItemMobile);
